<app-ui-confirmation-modal
  #wholesalerIntegration
  (confirm)="onGoToShoppingCart()"
  modalTitle="Shopping Cart"
  i18n-modalTitle="@@app.shopping_cart">
  @if (numberOfPositions > 0) {
    <p class="font-weight-bold">
      {{ numberOfPositions }} <ng-container i18n="@@app.positions">positions</ng-container>
    </p>
  }
  @if (preWiringDevicesIncluded) {
    <p class="mb-2" i18n="@@app.if_prewiring_is_needed_please_contact_the_wholesaler_directly">If prewiring is needed, please contact the wholesaler directly.</p>
  }
  @if (customDevicesIncluded) {
    <p i18n="@@app.we_found_custom_devices_in_your_bom">We found custom devices in your BOM. Be aware that they will not be transferred to shopping cart!</p>
    <div class="table-responsive">
      <table class="table table-condensed h-100-px overflow-y-auto">
        <thead>
          <tr>
            <th class="bg-blue-gray"><ng-container i18n="@@app.reference">Reference</ng-container></th>
            <th class="bg-blue-gray"><ng-container i18n="@@app.e_number">E-number</ng-container></th>
            <th class="bg-blue-gray"><ng-container i18n="@@app.description">Description</ng-container></th>
            <th class="bg-blue-gray"><ng-container i18n="@@app.quantity">Quantity</ng-container></th>
          </tr>
        </thead>
        <tbody>
          @for (model of bomModels; track model) {
            <tr>
              <td>{{ model?.article?.ref}}</td>
              <td>{{ model?.article.eNumber | convertZeroToEmpty }}</td>
              <td>{{ model?.article?.description }}</td>
              <td>{{ model?.quantity * numberOfApartments }}</td>
            </tr>
          }
          @for (model of bomModelsAccessories; track model) {
            <tr>
              <td>{{ model?.article?.ref}}</td>
              <td>{{ model?.article.eNumber | convertZeroToEmpty }}</td>
              <td>{{ model?.article?.description }}</td>
              <td>{{ model?.quantity * numberOfApartments }}</td>
            </tr>
          }
          @for (model of bomModelsProjectComponents; track model) {
            <tr>
              <td>{{ model?.article?.ref}}</td>
              <td>{{ model?.article.eNumber | convertZeroToEmpty }}</td>
              <td>{{ model?.article?.description }}</td>
              <td>{{ model?.quantity * numberOfApartments }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</app-ui-confirmation-modal>
